import { useCallback } from "react";
import { dataActions } from "@src/services/state/dataReducer";
import type * as TDT from "@tradingdroid/frontends-types";
import { useDispatch } from "react-redux";

import { useDataState } from "./data";

export const useSymbols = () => {
  const dispatch = useDispatch();
  const symbols = useDataState((state) => state.symbols);

  const getSymbol = useCallback(
    (exchangeName: string, symbolName: string): TDT.ApiSymbol | undefined => {
      const key = `${exchangeName}:${symbolName}`;
      return symbols[key];
    },
    [symbols],
  );

  const setSymbol = useCallback(
    (exchangeName: string, symbolName: string, symbol: TDT.ApiSymbol) => {
      const key = `${exchangeName}:${symbolName}`;
      dispatch(dataActions.setStateSymbol({ key, symbol }));
    },
    [dispatch],
  );

  const setSymbols = useCallback(
    (symbolsToCache: Record<string, TDT.ApiSymbol>) => {
      dispatch(dataActions.setStateSymbols(symbolsToCache));
    },
    [dispatch],
  );

  return {
    symbols,
    getSymbol,
    setSymbol,
    setSymbols,
  };
};
